import { useState } from "react";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { API_URL } from "../../../../core/config/env";
import Datatable from "../../../../core/ui/components/Datatable";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { sweetAl } from "../../../../core/helpers/message-helper";
import useModal from "../../../../core/hooks/use-modal";
import useUser from "../../../../core/hooks/use-user";
import {
    activarEntidadPension,
    inactivarEntidadPension,
} from "../../services/entidades-pension-service";
import FormEntidadesPension from "../components/form-entidades-pension";

const EntidadesPensiones = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalEntidadPension = useModal({
        title: "Crear la Entidad de Pension",
        data: { entidadPension: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSaved = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("crearEntidadesPension")) {
        tableButtons.push({
            titleAttr: "Agregar Entidad de Pension",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalEntidadPension.open({
                    title: "Agregar Entidad de Pension",
                    data: { entidadPension: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("editarEntidadesPension")) {
        tableButtons.push({
            titleAttr: "Editar Entidad de Pension",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalEntidadPension.open({
                    title: "Editar Entidad de Pension",
                    data: { entidadPension: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("inactivarEntidadesPension")) {
        tableButtons.push({
            titleAttr: "Inactivar Entidad de Pension",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta Entidad de Pension?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha inactivado la Entidad de Pension"
                        );
                        break;
                    case "eliminar": {
                        const resp = await inactivarEntidadPension(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la Entidad de Pension"
                            );
                        }

                        sweetAl.success(
                            "La Entidad de Pension fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("activarEntidadesPension")) {
        tableButtons.push({
            titleAttr: "Activar Entidad de Pension",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta Entidad de Pension?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha activado la Entidad de Pension"
                        );
                        break;
                    case "activar": {
                        const resp = await activarEntidadPension(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la Entidad de Pension"
                            );
                        }

                        sweetAl.success(
                            "La Entidad de Pension fue activado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "tipo-parametros",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaEntidadesPension",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/entidadesPension`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error listanto las Entidades de Pension"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "nit" },
            { data: "direccion" },
            { data: "telefono" },
            { data: "email" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [6],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Entidades De Pensión</div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaEntidadesPension"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Nit</th>
                            <th>Dirección</th>
                            <th>Telefono</th>
                            <th>Email</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormEntidadesPension
                modalState={modalEntidadPension}
                onSaved={onSaved}
            />
        </ContentWrapper>
    );
};

export default EntidadesPensiones;
